import {
  CONTACT_REQUEST_ACTION_STARTS,
  CONTACT_REQUEST_ACTION_ERRORS,
  RESET_CONTACT_REQUEST_ERRORS,
  GET_ALL_CONTACT_REQUESTS,
  GET_CONTACT_REQUEST,
  CREATE_CONTACT_REQUEST,
  UPDATE_CONTACT_REQUEST,
} from './actions';
import { ContactRequest } from '../../../../services/contactRequestServices/types';

interface ContactRequestState {
  contactRequests: ContactRequest[];
  selectedContactRequest: ContactRequest | null;
  contactRequestCreated: ContactRequest | null;
  contactRequestUpdated: ContactRequest | null;
  isLoading: boolean;
  isError: boolean;
  errorMessage: string | null;
  unreadCount: number;
}

const initialState: ContactRequestState = {
  contactRequests: [],
  selectedContactRequest: null,
  contactRequestCreated: null,
  contactRequestUpdated: null,
  isLoading: false,
  isError: false,
  errorMessage: null,
  unreadCount: 0
};

const contactRequestReducer = (state = initialState, action: any) => {
  let updatedRequests;
  
  switch (action.type) {
    case CONTACT_REQUEST_ACTION_STARTS:
      return {
        ...state,
        isLoading: true,
        isError: false,
        errorMessage: null,
      };
    case CONTACT_REQUEST_ACTION_ERRORS:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
      };
    case RESET_CONTACT_REQUEST_ERRORS:
      return {
        ...state,
        isError: false,
        errorMessage: null,
      };
    case GET_ALL_CONTACT_REQUESTS:
      return {
        ...state,
        contactRequests: action.payload,
        unreadCount: action.payload.filter((request: ContactRequest) => !request.is_read).length,
        isLoading: false,
      };
    case GET_CONTACT_REQUEST:
      return {
        ...state,
        selectedContactRequest: action.payload,
        isLoading: false,
      };
    case CREATE_CONTACT_REQUEST:
      return {
        ...state,
        contactRequestCreated: action.payload,
        contactRequests: [...state.contactRequests, action.payload],
        unreadCount: state.unreadCount + 1,
        isLoading: false,
      };
    case UPDATE_CONTACT_REQUEST:
      updatedRequests = state.contactRequests.map((contactRequest) =>
        contactRequest.id === action.payload.id ? action.payload : contactRequest
      );
      return {
        ...state,
        contactRequestUpdated: action.payload,
        contactRequests: updatedRequests,
        selectedContactRequest: action.payload,
        unreadCount: updatedRequests.filter((request: ContactRequest) => !request.is_read).length,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default contactRequestReducer; 